<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>TUGAS TAMBAHAN</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Tugas Tambahan</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jabatan.$error}">
            <label> Jabatan PTK </label>
            <j-input
              v-model="$v.data_master.jabatan.$model"
              placeholder="Jabatan PTK"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nomor_sk.$error}">
            <label> Nomor SK Tugas Tambahan </label>
            <j-input
              v-model="$v.data_master.nomor_sk.$model"
              type="number"
              placeholder="Nomor SK Tugas Tambahan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jam_per_minggu.$error}">
            <label> Jam Per Minggu </label>
            <j-input
              v-model="$v.data_master.jam_per_minggu.$model"
              type="number"
              placeholder="Jam Per Minggu"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tmt_tambahan.$error}">
            <label> TMT Tugas Tambahan </label>
            <j-datepicker
              v-model="$v.data_master.tmt_tambahan.$model"
              placeholder="TMT Tugas Tambahan"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tst_tambahan.$error}">
            <label> TST Tugas Tambahan </label>
            <j-datepicker
              v-model="$v.data_master.tst_tambahan.$model"
              placeholder="TST Tugas Tambahan"
              format="MMM dd, yyyy"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Tugas Tambahan</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jabatan.$error}">
            <label> Jabatan PTK </label>
            <j-input
              v-model="$v.data_master.jabatan.$model"
              :disabled="readOnly"
              placeholder="Jabatan PTK"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nomor_sk.$error}">
            <label> Nomor SK Tugas Tambahan </label>
            <j-input
              v-model="$v.data_master.nomor_sk.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Nomor SK Tugas Tambahan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jam_per_minggu.$error}">
            <label> Jam Per Minggu </label>
            <j-input
              v-model="$v.data_master.jam_per_minggu.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Jam Per Minggu"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tmt_tambahan.$error}">
            <label> TMT Tugas Tambahan </label>
            <j-datepicker
              v-model="$v.data_master.tmt_tambahan.$model"
              :disabled="readOnly"
              placeholder="TMT Tugas Tambahan"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tst_tambahan.$error}">
            <label> TST Tugas Tambahan </label>
            <j-datepicker
              v-model="$v.data_master.tst_tambahan.$model"
              :disabled="readOnly"
              placeholder="TST Tugas Tambahan"
              format="MMM dd, yyyy"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jTugasTambahan',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['jabatan', 'nomor_sk', 'jam_per_minggu', 'tmt_tambahan', 'tst_tambahan'],
      options: {
        headings: {
          jabatan: 'JABATAN PTK',
          nomor_sk: 'NOMOR SK TUGAS TAMBAHAN',
          jam_per_minggu: 'JAM PER MINGGU',
          tmt_tambahan: 'TMT TUGAS TAMBAHAN',
          tst_tambahan: 'TST TUGAS TAMBAHAN',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['jabatan', 'nomor_sk', 'jam_per_minggu', 'tmt_tambahan', 'tst_tambahan'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListTugasTambahan(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        jabatan: '',
        nomor_sk: null,
        jam_per_minggu: null,
        tmt_tambahan: null,
        tst_tambahan: null,
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createTugasTambahan', 'updateTugasTambahan', 'deleteTugasTambahan']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jabatan: '',
        nomor_sk: null,
        jam_per_minggu: null,
        tmt_tambahan: null,
        tst_tambahan: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jabatan: '',
        nomor_sk: null,
        jam_per_minggu: null,
        tmt_tambahan: null,
        tst_tambahan: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        jabatan: param.row.jabatan,
        nomor_sk: param.row.nomor_sk,
        jam_per_minggu: param.row.jam_per_minggu,
        tmt_tambahan: param.row.tmt_tambahan,
        tst_tambahan: param.row.tst_tambahan,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.createTugasTambahan(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.updateTugasTambahan(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteTugasTambahan(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        jabatan: { required },
        nomor_sk: { required },
        jam_per_minggu: { required },
        tmt_tambahan: { required },
        tst_tambahan: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jTugasTambahan.vue